"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.fixData = fixData;
const defaultValue_1 = require("./defaultValue");
const setData_1 = require("./setData");
const IOptions_1 = require("../WrappedProperty/IOptions");
/**
 * Naprawia dane, ustawiając domyślne wartości w polach
 *
 * @export
 * @param {JSONSchema} schema
 * @param {*} data
 * @param force mimo braku wartości domyslych ustwaia wartości w polach prostych
 * @returns {number} zwraca liczbę naprawionych pól
 */
function fixData(schema, data, force = true, options = IOptions_1.defaultOptions, currentPath = '') {
    let result = 0;
    if (schema.type === 'object') {
        const props = schema.properties;
        const path = currentPath ? currentPath + '.' : currentPath;
        for (const key in schema.properties) {
            const pschema = props[key];
            if (data[key] === undefined) {
                (0, setData_1.setDataValue)(pschema, data, key, (0, defaultValue_1.defaultValue)(pschema, force, undefined, options, path + key));
                result++;
            }
            else if (data[key] === null && (pschema.type === 'array' || pschema.type === 'object')) {
                (0, setData_1.setDataValue)(pschema, data, key, (0, defaultValue_1.defaultValue)(pschema, force, undefined, options, path + key));
                result++;
            }
            else {
                result += fixData(pschema, data[key], force, options, path + key);
            }
        }
    }
    else if (schema.type === 'array') {
        const pschema = schema.items;
        // tslint:disable-next-line: prefer-for-of
        for (let i = 0; i < data.length; i++) {
            const value = data[i];
            result += fixData(pschema, value, force, options, currentPath + '[' + i + ']');
        }
    }
    return result;
}
exports.default = fixData;
//# sourceMappingURL=fixData.js.map